import React, { useEffect, useState, } from "react";
import {
  Box,
  Divider,
  Typography,
  TextField,
  IconButton,
  Button,
  Paper,
  Chip,
  Grid,
  Select, MenuItem, OutlinedInput,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import { useTheme } from "@mui/material/styles"; //  Added useTheme
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import LockIcon from "@mui/icons-material/Lock";
import { useToast } from "../components/ToastContext";
import { api } from "../services/api";
import { useNavigate,useLocation } from "react-router-dom";
import { evaluateAndReturn } from "../Utils/common";
import PropTypes from "prop-types";
import RoleGuard from "../components/RoleGuard";


const AwsAdditionalTag = ({ resourceOverview, resourceTypeId, resourceStatus }) => {
  const theme = useTheme(); //  Initialize theme
  const isDark = theme.palette.mode === 'dark'; // Master dark mode check


  const location = useLocation();
    const { resourceId } = location.state || {};
    const { resourceName } = location.state || {};
  const [tags, setTags] = useState([{ name: "", value: "" }]);
  const [existingTagsState, setExistingTagsState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();


const hasRestrictedResource =
  resourceOverview?.resourceRequestDetails?.some(item =>
    ["alb", "nlb"].includes(item?.resourceName?.toLowerCase())
  );
  

const allowedStatuses = ["running", "stopped"];

const hideAddTags = ["alb", "nlb", "rds"].includes(resourceName?.toLowerCase()) || hasRestrictedResource ||  !allowedStatuses.includes((resourceStatus || "").toLowerCase());

  // ========== TAG CATEGORIES ==========
  const TAG_CATEGORIES = {
    GENERAL: 'General',
    OPTIONAL: 'Optional',
    LOGIC_MONITOR: 'Logic Monitor'
  };

  const categorizeTag = (subTab) => {
    // if (!subTab) return TAG_CATEGORIES.GENERAL;
    if (!subTab) return TAG_CATEGORIES.OPTIONAL;

    const lower = subTab.toLowerCase();
    if (lower.includes('logic') || lower.includes('monitor')) {
      return TAG_CATEGORIES.LOGIC_MONITOR;
    }
    if (lower.includes('optional')) {
      return TAG_CATEGORIES.OPTIONAL;
    }
    return TAG_CATEGORIES.GENERAL;
  };

  const groupTagsByCategory = (tagsArray) => {
    const grouped = {
      [TAG_CATEGORIES.GENERAL]: [],
      [TAG_CATEGORIES.OPTIONAL]: [],
      [TAG_CATEGORIES.LOGIC_MONITOR]: []
    };
    tagsArray.forEach(tag => {
      const category = categorizeTag(tag.subTab);
      grouped[category].push(tag);
    });
    return grouped;
  };

  const existingTags = resourceOverview?.resourceRequestDetails?.filter(
    (item) => item.tabName === "Tag"
  ) || [];

  // Initialize existing tags state - FIXED DEPENDENCY
  useEffect(() => {
    if (existingTags.length > 0) {
      const initialState = existingTags.map(tag => ({
        ...tag,
        originalValue: tag.type == "dropdown" ? tag.fieldValue : tag.fieldData,
        // isEditable: !protectedTags.includes(tag.fieldName.toLowerCase()) && resourceStatus != "running",
        // isEditable: !protectedTags.includes(tag.fieldName.toLowerCase()) &&
        //   !(resourceStatus === "running" && tag.fieldName.toLowerCase() === "environment"),
isEditable:
  tag.isEnabledTags &&
  !(resourceStatus === "running" &&
    tag.fieldName.toLowerCase() === "environment"),

        hasChanged: false,
        type: tag.type,
        options: tag.options,
        category: categorizeTag(tag.subTab)
      }));
      setExistingTagsState(initialState);
    }
  }, [resourceOverview?.resource_Id]); 

  // Handle existing tag value change
  const handleExistingTagChange = (idx, newValue, type) => {
    setExistingTagsState(prev => {
      const updated = [...prev]; // Create new array
      if (type == "dropdown") {
        updated[idx] = {
          ...updated[idx],
          fieldValue: newValue,
          hasChanged: newValue !== updated[idx].originalValue
        };
      }
      if (type != "dropdown") {
        updated[idx] = {
          ...updated[idx],
          fieldData: newValue,
          hasChanged: newValue !== updated[idx].originalValue
        };
      }

      // Check if any changes exist
      const anyExistingChanges = updated.some(tag => tag.hasChanged);
      const anyNewTags = tags.some(tag => tag.name.trim() || tag.value.trim());
      setHasChanges(anyExistingChanges || anyNewTags);

      return updated;
    });
  };

  // Handle new tag changes
  const handleTagChange = (idx, field, value) => {
    setTags((prev) => {
      const updated = [...prev]; // Create new array
      updated[idx] = { ...updated[idx], [field]: value };

      // Check for changes
      const anyNewTags = updated.some(tag => tag.name.trim() || tag.value.trim());
      const anyExistingChanges = existingTagsState.some(tag => tag.hasChanged);
      setHasChanges(anyNewTags || anyExistingChanges);

      return updated;
    });
  };

  const handleAddTag = () => {
    setTags((prev) => [...prev, { name: "", value: "" }]);
  };

  const handleRemoveTag = (idx) => {
    if (tags.length === 1) {
      setTags([{ name: "", value: "" }]);
      const anyExistingChanges = existingTagsState.some(tag => tag.hasChanged);
      setHasChanges(anyExistingChanges);
    } else {
      setTags((prev) => {
        const updated = prev.filter((_, i) => i !== idx);
        const anyNewTags = updated.some(tag => tag.name.trim() || tag.value.trim());
        const anyExistingChanges = existingTagsState.some(tag => tag.hasChanged);
        setHasChanges(anyNewTags || anyExistingChanges);
        return updated;
      });
    }
  };

  // Validation helper
  const validateTags = () => {
    const names = new Set();

    existingTagsState.forEach(tag => {
      names.add(tag.fieldName.trim().toLowerCase());
    });

    const filteredNewTags = tags.filter(tag => tag.name.trim() && tag.value.trim());

    for (let i = 0; i < filteredNewTags.length; i++) {
      const { name, value } = filteredNewTags[i];
      const lowerName = name.trim().toLowerCase();

      if (!name.trim() || !value.trim()) {
        toast.error("Tag name and value cannot be empty.");
        return false;
      }

      if (names.has(lowerName)) {
        toast.error(`Duplicate tag name "${name}" is not allowed.`);
        return false;
      }

      names.add(lowerName);
    }
    return true;
  };

  const handleSaveChanges = async () => {
    if (!validateTags()) return;

    setLoading(true);
    try {
      const allTags = {};

      existingTagsState.forEach(tag => {
        allTags[tag.fieldName] = tag.type == "dropdown" ? tag.fieldValue : tag.fieldData;
      });

      const filteredNewTags = tags.filter(tag => tag.name.trim() && tag.value.trim());
      filteredNewTags.forEach(tag => {
        allTags[tag.name.trim()] = tag.value.trim();
      });

      const payload = {
        resource_Id: resourceOverview?.resource_Id?.toString() || "",
        requester: sessionStorage.getItem("userId") || "",
        resourceType: resourceTypeId,

        organizationId: Number.parseInt(sessionStorage.getItem("organizationId")),
        resourceRequest: JSON.stringify(allTags)
      };

      const response = await api.post("/api/Resources/updateTags", payload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Tags updated successfully.");

      setExistingTagsState(prev => {
        const updatedExisting = prev.map(tag => ({
          ...tag,
          originalValue: tag.fieldData,
          hasChanged: false
        }));

        const newTagsAsExisting = filteredNewTags.map(tag => ({
          fieldName: tag.name.trim(),
          fieldData: tag.value.trim(),
          originalValue: tag.value.trim(),
          // isEditable: !protectedTags.includes(tag.name.trim().toLowerCase()),
          // isEditable: tag.isEnabledTags,
          isEditable: true,
isEnabledTags: true,
          hasChanged: false,
          tabName: "Tag",
          subTab: "Optional",
          category: "Optional"
        }));

        return [...updatedExisting, ...newTagsAsExisting];
      });

      setTags([{ name: "", value: "" }]);
      setHasChanges(false);
      navigate("/provision-status");

    } catch (error) {
      console.error("Error updating tags:", error);
      toast.error("Failed to update tags. Please try again.");
    }
    setLoading(false);
  };

  const handleDiscard = () => {
    setExistingTagsState(prev =>
      prev.map(tag => ({
        ...tag,
        fieldData: tag.originalValue,
        hasChanged: false
      }))
    );

    setTags([{ name: "", value: "" }]);
    setHasChanges(false);
    toast.info("All changes discarded.");
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto' }}>

      {/* Existing Tags Section */}
      {existingTagsState.length > 0 && (
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Existing Tags
              </Typography>
            </Box>

            <Chip
              label={`${existingTagsState.length} tags`}
              size="small"
              sx={{
                //  Theme-aware chip colors
                backgroundColor: isDark ? 'rgba(144, 202, 249, 0.16)' : '#e3f2fd',
                color: isDark ? '#90caf9' : '#1976d2',
                fontWeight: 500
              }}
            />
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
            <LockIcon sx={{ fontSize: 16, color: 'text.secondary', mr: 1 }} />
            Tags marked with a lock icon are protected and cannot be edited.
          </Typography>

          {Object.entries(groupTagsByCategory(existingTagsState)).map(([category, categoryTags]) =>
            categoryTags.length > 0 && (
              <Accordion key={category} defaultExpanded sx={{ mb: 2 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {category}
                  </Typography>
                  <Chip
                    label={`${categoryTags.length} tags`}
                    size="small"
                    sx={{
                      ml: 2,
                      //  Theme-aware chip colors
                      backgroundColor: isDark ? 'rgba(144, 202, 249, 0.16)' : '#e3f2fd',
                      color: isDark ? '#90caf9' : '#1976d2',
                      fontWeight: 500
                    }}
                  />
                </AccordionSummary>
                <AccordionDetails>
                  {categoryTags.map((tag) => {
                    const realIndex = existingTagsState.findIndex(t => t.fieldName === tag.fieldName);

                    return (
                      <Box key={`existing-${realIndex}`} sx={{ mb: 3 }}>
                        <Grid container spacing={2}>

                          <Grid item xs={12} sm={6}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <Typography variant="subtitle2" sx={{ fontWeight: 500, mr: 1 }}>
                                Tag Name
                              </Typography>
                              <LockIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                            </Box>

                            <TextField
                              value={tag.fieldName}
                              slotProps={{
                                input: {
                                  readOnly: true,
                                },
                              }} size="small"
                              fullWidth
                              sx={{
                                "& .MuiInputBase-root": {
                                  //  Theme-aware disabled background
                                  backgroundColor: isDark ? 'action.disabledBackground' : '#f5f5f5',
                                },
                                height: 20
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <Typography variant="subtitle2" sx={{ fontWeight: 500, mr: 1 }}>
                                Tag Value
                              </Typography>
                              {!tag.isEditable && <LockIcon sx={{ fontSize: 16, color: 'text.secondary' }} />}
                            </Box>

                            {evaluateAndReturn(tag.type == "dropdown",
                              <Select
                                value={tag.fieldValue}
                                onChange={tag.isEditable ? (e) =>
                                  handleExistingTagChange(realIndex, e.target.value, tag.type)
                                  : undefined
                                }
                                disabled={!tag.isEditable}
                                input={<OutlinedInput />}
                                fullWidth
                                sx={{
                                  '& .MuiSelect-select': {
                                    padding: '9px 35px 9px 12px',
                                  },
                                  minWidth: 250,
                                  width: '100%',

                                }}
                              >
                                {tag.options?.map(d => <MenuItem key={d.value} value={d.value}>{d.text}</MenuItem>)}
                              </Select>,

                              <TextField
                                value={tag.fieldData}
                                onChange={tag.isEditable ? (e) =>
                                  handleExistingTagChange(realIndex, e.target.value, tag.type)
                                  : undefined
                                }
                                slotProps={{
                                  input: { readOnly: !tag.isEditable },
                                }}
                                size="small"
                                fullWidth
                                sx={{
                                  "& .MuiInputBase-root": {
                                    //  Complex logic mapped for Dark Mode
                                    backgroundColor: tag.isEditable 
                                      ? (tag.hasChanged ? (isDark ? 'rgba(255, 152, 0, 0.16)' : '#fff3e0') : (isDark ? 'background.paper' : 'white')) 
                                      : (isDark ? 'action.disabledBackground' : '#f5f5f5'),
                                  },
                                  height: 20,
                                  minWidth: 250,
                                }}
                              />
                            )}
                          </Grid>

                        </Grid>
                      </Box>
                    );
                  })}

                </AccordionDetails>
              </Accordion>
            )
          )}

{!hideAddTags && 
(<>
          {/* Add New Tags Section */}
          <Divider sx={{ my: 3 }} />

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Add New Tags
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Tag names must be unique and not empty. Avoid sensitive information.
          </Typography>

          {tags.map((tag, idx) => (
            <Box key={`new-${idx}`} sx={{ mb: 3 }}>
              <Grid container spacing={2} alignItems="center">


                <Grid item xs={12} sm={5}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                    Tag Name
                  </Typography>
                  <TextField
                    value={tag.name || ''}
                    onChange={e => {
                      handleTagChange(idx, "name", e.target.value);
                    }}
                    placeholder="Enter tag name"
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ height: 20 }}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                    Tag Value
                  </Typography>
                  <TextField
                    value={tag.value || ''}
                    onChange={e => {
                      handleTagChange(idx, "value", e.target.value);
                    }}
                    placeholder="Enter tag value"
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ height: 20 }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={2}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    paddingTop: '35px'
                  }}
                >
                  <IconButton
                    onClick={() => handleRemoveTag(idx)}
                    disabled={tags.length === 1}
                    color="error"
                  >
                    <CloseIcon />
                  </IconButton>
                </Grid>

              </Grid>
            </Box>
          ))}
          <br />

          {/* Action Buttons */}
          <RoleGuard requiredPermission="MANAGE_TAGS">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3 }}>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => handleAddTag()}
              disabled={loading}
            >
              Add Tag
            </Button>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                onClick={handleDiscard}
                disabled={loading}
                color="primary"
                variant="cancelContained"
              >
                Discard
              </Button>
              <Button
                onClick={handleSaveChanges}
                variant="contained"
                color="primary"
                disabled={loading || !hasChanges}
              >
                {loading ? "Saving..." : "Save Changes"}
              </Button>
            </Box>
          </Box>
          </RoleGuard>
          </>)
}

        </Box>
      )}
{!hideAddTags && (
  <>
      {/* Show this if no existing tags */}
      {existingTagsState.length === 0 && (
        <Paper sx={{ p: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Add New Tags
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Tag names must be unique and not empty. Avoid sensitive information.
          </Typography>

          {tags.map((tag, idx) => (
            <Box key={`new-only-${idx}`} sx={{ mb: 3 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={5}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                    Tag Name
                  </Typography>
                  <TextField
                    value={tag.name || ''}
                    onChange={e => handleTagChange(idx, "name", e.target.value)}
                    placeholder="Enter tag name"
                    size="small"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                    Tag Value
                  </Typography>
                  <TextField
                    value={tag.value || ''}
                    onChange={e => handleTagChange(idx, "value", e.target.value)}
                    placeholder="Enter tag value"
                    size="small"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
  
                <Grid
                  item
                  xs={12}
                  sm={2}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    paddingTop: '35px',
                  }}
                >
                  <IconButton
                    onClick={() => handleRemoveTag(idx)}
                    disabled={tags.length === 1}
                    color="error"
                  >
                    <CloseIcon />
                  </IconButton>
                </Grid>

              </Grid>
            </Box>
          ))}
          <br />
           <RoleGuard requiredPermission="MANAGE_TAGS">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3 }}>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => handleAddTag()}
              disabled={loading}
            >
              Add Tag
            </Button>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                onClick={handleDiscard}
                disabled={loading}
                color="primary"
                variant="cancelContained"
              >
                Discard
              </Button>
              <Button
                onClick={handleSaveChanges}
                disabled={loading || !hasChanges}
                variant="contained"
                color="primary"
              >
                {loading ? "Saving..." : "Save Changes"}
              </Button>
            </Box>
          </Box>
           </RoleGuard>  
        </Paper>
      )}
      </>)}
    </Box>
  );
};

AwsAdditionalTag.propTypes = {
  resourceOverview: PropTypes.shape({
    applicationName: PropTypes.string,
    resource_Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    resourceRequestDetails: PropTypes.arrayOf(
      PropTypes.shape({
        tabName: PropTypes.string,
        fieldName: PropTypes.string,
        fieldData: PropTypes.string,
        fieldValue: PropTypes.any,
        type: PropTypes.string,
        subTab: PropTypes.string,
        options: PropTypes.array,
      })
    ),
  }).isRequired,
  resourceTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  resourceStatus: PropTypes.string,
};

export default AwsAdditionalTag;